import {
  aCreateSuppressList,
  aSuppressList,
  mockCreateSuppressedListOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const createSuppressedListHandler = ({
  id,
  name,
  description,
  timeToLiveInSeconds,
}) => ({
  __typename: 'Mutation',
  createSuppressList: {
    ...aCreateSuppressList(),
    data: aSuppressList({
      defaultTtl: timeToLiveInSeconds,
      description,
      id,
      name,
      targetColumn: '1',
    }),
  },
});

export const handlers = [
  mockCreateSuppressedListOperationMutation(
    async ({ query: _query, variables }) => {
      await delay(1500);
      const { defaultTtl, description, name, targetColumn } = variables.fields;

      return HttpResponse.json({
        data: {
          __typename: 'Mutation',
          createSuppressList: aCreateSuppressList({
            data: aSuppressList({
              id: '0',
              defaultTtl,
              description,
              name,
              targetColumn,
            }),
          }),
        },
      });
    }
  ),
];
